import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
import { useDispatch } from 'react-redux';
import { getAllUsersPaginateAsyncThunk, updateUserAsyncThunk } from '../../store/user/userSlice';

// Şifre validasyon fonksiyonu
const validatePassword = (password) => {
    if (!password) return { isValid: true, isEmpty: true }; // Şifre boşsa geçerli (değiştirilmeyecek)

    const minLength = password.length >= 8;
    const hasLowercase = /[a-z]/.test(password);
    const hasUppercase = /[A-Z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecial = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password);

    return {
        minLength,
        hasLowercase,
        hasUppercase,
        hasNumber,
        hasSpecial,
        isValid: minLength && hasLowercase && hasUppercase && hasNumber && hasSpecial,
        isEmpty: false
    };
};

export default function EditDialog({ show, selectedUser, hideDialog, onEditUser }) {
    const [submitted, setSubmitted] = useState(false);
    const [selected, setSelected] = useState({});
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const dispatch = useDispatch();

    const passwordValidation = validatePassword(selected.password);

    const options = [
        { label: 'Admin', value: 'admin' },
        { label: 'User', value: 'user' }
    ];

    useEffect(() => {
        if (selectedUser) {
            setSelected(selectedUser);
        }
    }, [selectedUser]);

    const onInputChange = (e, name) => {
        const val = e.target ? e.target.value : e.value;
        let _user = { ...selected };
        _user[`${name}`] = val;
        setSelected(_user);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!selected.name.trim()) {
            setSubmitted(true);
            return;
        }
        if (!selected.email.trim()) {
            setSubmitted(true);
            return;
        }
        /* if (!selected.role.trim()) {
            setSubmitted(true);
            return;
        } */
        // Şifre girilmişse validasyonu kontrol et
        if (selected.password && !passwordValidation.isValid) {
            setSubmitted(true);
            return;
        }
        // Telefon validasyonu
        if (!selected.phone || selected.phone.includes('_')) {
            setSubmitted(true);
            return;
        }

        setLoading(true);
        onEditUser();
        const cleanPhone = selected.phone ? selected.phone.replace(/\s/g, '') : '';
        await dispatch(
            updateUserAsyncThunk({
                name: selected.name,
                email: selected.email,
                phone: cleanPhone,
                /* role: selected.role, */
                id: selected.id,
                password: selected.password === '' ? null : selected.password
            })
        );
        await dispatch(
            getAllUsersPaginateAsyncThunk({
                page: 0,
                limit: 10,
                sortField: null,
                sortOrder: null,
                filters: {
                    name: { operator: 'AND', constraints: [{ value: '', matchMode: 'contains' }] },
                    email: { operator: 'AND', constraints: [{ value: '', matchMode: 'contains' }] }
                }
            })
        );
        setLoading(false);
        setSelected({});
        setSubmitted(false);
    };

    const userDialogFooter = (
        <React.Fragment>
            <Button label="İptal" icon="pi pi-times" outlined onClick={hideDialog} disabled={loading} />
            <Button label="Kaydet" icon="pi pi-check" onClick={(e) => handleSubmit(e)} type="submit" loading={loading} />
        </React.Fragment>
    );

    if (!selectedUser) {
        return null;
    }

    return (
        <Dialog visible={show} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Kullanıcı Güncelle" modal className="p-fluid" footer={userDialogFooter} onHide={hideDialog}>
            <form onSubmit={handleSubmit}>
                <div className="field">
                    <label htmlFor="Kullanıcı Adı" className="font-bold">
                        Kullanıcı Adı
                    </label>
                    <InputText id="name" value={selected.name} onChange={(e) => onInputChange(e, 'name')} required autoFocus className={classNames({ 'p-invalid': submitted && !selected.name })} placeholder="Kullanıcı Adı" />
                    {submitted && !selected.name && <small className="p-error">Kullanıcı Adı gerekli.</small>}
                </div>
                <div className="field">
                    <label htmlFor="E-Mail" className="font-bold">
                        E-Mail
                    </label>
                    <InputText id="E-Mail" value={selected.email} onChange={(e) => onInputChange(e, 'email')} required className={classNames({ 'p-invalid': submitted && !selected.email })} placeholder="E-Mail" />
                    {submitted && !selected.email && <small className="p-error">Email gerekli.</small>}
                </div>

                <div className="field">
                    <label htmlFor="phone" className="font-bold">
                        Telefon
                    </label>
                    <InputMask
                        id="phone"
                        value={selected.phone || ''}
                        onChange={(e) => onInputChange(e, 'phone')}
                        mask="0599 999 99 99"
                        placeholder="05XX XXX XX XX"
                        required
                        className={classNames({ 'p-invalid': submitted && (!selected.phone || selected.phone.includes('_')) })}
                    />
                    {submitted && (!selected.phone || selected.phone.includes('_')) && <small className="p-error">Geçerli bir telefon numarası gerekli.</small>}
                </div>

                <div className="field">
                    <label htmlFor="Şifre" className="font-bold">
                        Şifre
                    </label>
                    <div className="p-inputgroup">
                        <InputText
                            id="Şifre"
                            type={showPassword ? 'text' : 'password'}
                            value={selected.password || ''}
                            onChange={(e) => onInputChange(e, 'password')}
                            placeholder="Şifre (değiştirmek için doldurun)"
                            className={classNames({ 'p-invalid': submitted && selected.password && !passwordValidation.isValid })}
                        />
                        <span className="p-inputgroup-addon cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
                            <i className={showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'}></i>
                        </span>
                    </div>
                    {submitted && selected.password && !passwordValidation.isValid && <small className="p-error">Şifre gereksinimleri karşılanmıyor.</small>}

                    {/* Şifre Gereksinimleri - sadece şifre girilmeye başlandığında göster */}
                    {selected.password && (
                        <div className="text-sm mt-2">
                            <p className="m-0 mb-2 font-semibold">Şifre Gereksinimleri:</p>
                            <ul className="m-0 pl-4" style={{ listStyle: 'none' }}>
                                <li className={passwordValidation.minLength ? 'text-green-500' : 'text-red-500'}>
                                    <i className={`pi ${passwordValidation.minLength ? 'pi-check' : 'pi-times'} mr-2`}></i>
                                    En az 8 karakter
                                </li>
                                <li className={passwordValidation.hasLowercase ? 'text-green-500' : 'text-red-500'}>
                                    <i className={`pi ${passwordValidation.hasLowercase ? 'pi-check' : 'pi-times'} mr-2`}></i>
                                    En az 1 küçük harf (a-z)
                                </li>
                                <li className={passwordValidation.hasUppercase ? 'text-green-500' : 'text-red-500'}>
                                    <i className={`pi ${passwordValidation.hasUppercase ? 'pi-check' : 'pi-times'} mr-2`}></i>
                                    En az 1 büyük harf (A-Z)
                                </li>
                                <li className={passwordValidation.hasNumber ? 'text-green-500' : 'text-red-500'}>
                                    <i className={`pi ${passwordValidation.hasNumber ? 'pi-check' : 'pi-times'} mr-2`}></i>
                                    En az 1 rakam (0-9)
                                </li>
                                <li className={passwordValidation.hasSpecial ? 'text-green-500' : 'text-red-500'}>
                                    <i className={`pi ${passwordValidation.hasSpecial ? 'pi-check' : 'pi-times'} mr-2`}></i>
                                    En az 1 özel karakter (!@#$%^&* vb.)
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
                {/* <div className="field">
                    <label htmlFor="Rol" className="font-bold">
                        Rol
                    </label>
                    <Dropdown
                        id="Rol"
                        value={selected.role}
                        options={options}
                        onChange={(e) => onInputChange(e, 'role')}
                        placeholder="Rol"
                        filter
                        className={classNames({ 'p-invalid': submitted && !selected.role })}
                    />
                    {submitted && !selected.role && <small className="p-error">Rol gerekli.</small>}
                </div> */}
            </form>
        </Dialog>
    );
}
